<script>
  import { onMount } from "svelte";
  import {
    container,
    containerBBox,
    containerW,
    containerH,
    windowW,
  } from "../../stores/dimensions";
  import Portal from "./Portal.svelte";
  import Icon from "../Helpers/Icon.svelte";
  import { clickOutside } from "../../utils/clickOutside.js";

  export let icon = "question-circle-Solid";
  export let content;
  export let color = "#1C5A70";
  export let promptClass = null;
  export let yTranslate = "0";
  export let yTranslateDir = "-";
  export let hidden = false;
  $: hiddenClass = hidden ? "opacity-0 pointer-events-none" : "";

  let visible = false,
    m = { x: 0, y: 0 },
    ttWidth = 320,
    ttHeight = 100,
    left,
    top,
    mounted,
    windowH,
    ttYdir = "";

  onMount(async () => {
    setTimeout(() => (mounted = true), 250);
  });

  function mousemove(e) {
    // left = $containerBBox ? $containerBBox.left : 0;
    left = 0;
    top = $containerBBox ? $containerBBox.top : 0;
    if (mounted) {
      visible = true;
      m.x =
        e.clientX - left + 320 > $windowW - 32
          ? $windowW - 320 - 32
          : e.clientX - left;
      m.y = e.clientY;
    }
  }

  function close() {
    visible = false;
  }
</script>

<svelte:window bind:innerHeight={windowH} on:scroll={close} />

{#if mounted}
  <div
    class="inline-block transform {yTranslateDir}translate-y-{yTranslate} {promptClass} hover:opacity-80 transition cursor-pointer {hiddenClass}"
    on:mousemove={mousemove}
    on:mouseout={close}
  >
    <Icon name={icon} fill={color} />
  </div>
  <!-- targetClass="container" -->
  {#if visible}
    <Portal className="fixed z-50" targetId="content">
      <div
        class="fixed p-2 bg-white border rounded-md border-blue-light shadow-lg w-80 z-50 {visible
          ? 'block'
          : 'hidden'}"
        style="top: {m.y}px; left: {m.x}px; transform: translate(4px, {m.y +
          ttHeight >
        windowH - 32
          ? -ttHeight - 12
          : 12}px)"
        bind:clientWidth={ttWidth}
        bind:clientHeight={ttHeight}
        on:click={close}
        use:clickOutside
        on:click_outside={() => {
          console.log("click outside");
          // if (visible) visible = false;
        }}
      >
        <div>
          <p class="mb-0 text-sm text-neutral lg:text-base">{@html content}</p>
        </div>
      </div>
    </Portal>
  {/if}
{/if}

<style>
  .z-50 {
    z-index: 999;
  }
</style>
